import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import Button from './formControls/Button';

const BETA_URL = 'https://beta.web.youneed.it';

const BetaRedirectModal = ({ isOpen, onClose }) => {
  const goToBeta = () => {
    window.location.href = BETA_URL;
  };

  return (
    <Modal isOpen={isOpen} className="modal-md" backdrop="static" keyboard={false}>
      <ModalBody>
        <p className="mb-2">Ti ricordo che è attiva una fase di beta test.</p>
        <p className="mb-0">
          In questa fase è importantissimo il contributo di tutti, per cui sei invitato ad
          accedere alla versione di beta di YouNeed.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button className="btn btn-primary" onClick={goToBeta} text="Vai alla beta" />
        <Button className="btn btn-outline-primary" onClick={onClose} text="Continua qui" />
      </ModalFooter>
    </Modal>
  );
};

BetaRedirectModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BetaRedirectModal;
